function BuyNowButton(){
  return(
    <stripe-buy-button
      buy-button-id="buy_btn_1P1MYNAHqa13PPrccnc9PcK7"
      publishable-key="pk_live_51O0WghAHqa13PPrcNypkStarwcvTPu5xST0RayuYaGXuaoDYv22lc0GMD0ahIeRRscMuBpAgBT716N1vPIf0AFUO003HoKaRCt">
    </stripe-buy-button>
  )
}

export default BuyNowButton;